import api from "./api/api";

interface GetNotificationsParams {
  page?: number;
  perPage?: number;
  s?: string;
  type?:
    | "desk"
    | "reuniao"
    | "shared"
    | "recrutamento"
    | "feedback"
    | "social"
    | "engajamento";
  unread?: boolean;
}

const NotificationsService = {
  get: async (params?: GetNotificationsParams) => {
    try {
      const searchParams = new URLSearchParams();
      searchParams.set("page", String(params?.page ?? 1));
      searchParams.set("perPage", String(params?.perPage ?? 20));
      if (params?.s) searchParams.set("s", params.s);
      if (params?.type) searchParams.set("type", params.type);
      if (params?.unread) searchParams.set("unread", "true");
      const res = await api.get(`/notifications?${searchParams.toString()}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  read: async (id: any) => {
    try {
      const res = await api.get(`/notifications/read/${id}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  readAll: async () => {
    try {
      const res = await api.patch(`/notifications/marcar-todas-lidas`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
};

export default NotificationsService;
